import { EllipsisVerticalIcon } from "@heroicons/react/24/outline"
import { Checkbox, Dropdown, Spin } from "antd"
import { memo, useEffect, useRef, useState } from "react"
import maximizeIcon from "assets/svg/maximize-one.svg"
import requestQoute from "assets/svg/quote-request 2.svg"
import { getInitials, PillBadge, TimeText } from "./TimeSheetActivityRow"

interface ActivityRowProps {
  name: string
  clockIn: string
  clockOut: string
  flags?: string[]
  reason?: string
  status?: number
  id: React.Key
  selectRow: (id: React.Key) => void
  isSelected: boolean
  viewUserProfile: () => void
  showModalReason: () => void
  acceptShiftPeriodModal: () => void
  rejectShiftPeriodModal: () => void
  rejectDetailsModal: () => void
  isLoading?: boolean
}

const OvertimeTimeSheetActivityRow = memo(
  ({
    id,
    name,
    clockIn,
    clockOut,
    flags = [],
    reason,
    status,
    selectRow,
    isSelected,
    viewUserProfile,
    showModalReason,
    acceptShiftPeriodModal,
    rejectShiftPeriodModal,
    isLoading,
    rejectDetailsModal,
  }: ActivityRowProps) => {
    const textRef = useRef<HTMLParagraphElement | null>(null)
    const [showButton, setShowButton] = useState(false)

    useEffect(() => {
      const el = textRef.current
      if (el) {
        setShowButton(el.scrollHeight > el.clientHeight)
      }
    }, [reason])

    return (
      <div className="w-full grid grid-cols-[200px_164px_164px_164px_280px_148px] h-36 items-center border-b border-b-gray-300">
        {" "}
        {/* User */}
        <div className="flex items-center gap-2 shrink-0">
          <Checkbox
            onChange={() => selectRow(id)}
            checked={isSelected}
          />
          <span className="rounded-full w-10 h-10 flex justify-center items-center bg-[#E2E8F0] p-1 font-semibold text-sm">
            {getInitials(name)}
          </span>
          <p
            className="truncate min-w-0 hover:underline hover:cursor-pointer"
            onClick={viewUserProfile}
          >
            {name}
          </p>
        </div>
        {/* Time */}
        <TimeText value={clockIn} />
        <TimeText value={clockOut} />
        {/* Method */}
        <div className="flex items-center gap-2 whitespace-nowrap">
          <img
            width={15}
            height={15}
            src={requestQoute}
          />
          <span className="text-sm truncate">Manuel overtime entry</span>
        </div>
        {/* Reason */}
        <div className="flex items-center px-4 flex-wrap">
          <p
            ref={textRef}
            className="min-w-0 line-clamp-3 break-all"
          >
            {reason}
          </p>
          {showButton && (
            <span
              className="flex text-sm items-center gap-2 bg-[#F1F5F9] px-3 py-1 rounded-full w-fit cursor-pointer"
              onClick={showModalReason}
            >
              {" "}
              <img
                src={maximizeIcon}
                width={10}
                height={10}
              />
              Expand
            </span>
          )}
        </div>
        {/* Action */}
        <div className="shrink-0 w-fit">
          <>
            {status === 1 ? (
              <p className="text-green-600">Approved</p>
            ) : status === 2 ? (
              <Dropdown
                menu={{
                  items: [
                    {
                      key: "1",
                      label: "View rejection details",
                      onClick: rejectDetailsModal,
                    },
                    // {
                    //   key: "2",
                    //   label: "Change to Approved",
                    //   onClick: acceptShiftPeriodModal,
                    // },
                  ],
                }}
              >
                <button className="flex items-center gap-1">
                  <span className="text-red-600">Rejected</span>
                  <EllipsisVerticalIcon className="w-6 h-6 text-[#004AF5]" />
                </button>
              </Dropdown>
            ) : (
              <>
                {isLoading ? (
                  <Spin>
                    <div className="h-[94px] w-full bg-white rounded-lg border" />
                  </Spin>
                ) : (
                  <div className="flex gap-2 items-center justify-center">
                    <button
                      onClick={acceptShiftPeriodModal}
                      className="border-2 border-[#E2E8F0] w-[35px] h-[35px] rounded-md flex justify-center items-center hover:border-green transition-all"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-5 h-5 hover:text-green transition-all"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="m4.5 12.75 6 6 9-13.5"
                        />
                      </svg>
                    </button>
                    <button
                      onClick={rejectShiftPeriodModal}
                      className="border-2 border-[#E2E8F0] w-[35px] h-[35px] rounded-md flex justify-center items-center hover:border-red-500 transition-all"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-5 h-5 hover:text-red-500 transition-all"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18 18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                )}
              </>
            )}
          </>
        </div>
      </div>
    )
  }
)

export default OvertimeTimeSheetActivityRow
